
(function() {
    /**
     * A set of ability functions which take the team (array of cards) 
     * of the user of the ability as the first param and the team of 
     * the current enemy as the second param.
     * 
     * WARNING: some abilities could kill the enemy
     * 
     * Assumes all card attribute values are numbers.
     */
    
        window.effects = {
    
            add(card, effects, timeout = 1300) {
                for (let effect of effects) {
                    //document.getElementById(card.id).classList.add(`-${effect}`);
                    $(`#${card.id} .playing-card-wrapper`).addClass(`-${effect}`);
    
                    let audio = new Audio('../audio/rise-01.mp3');
                    audio.play();
    
                    setTimeout(function() {
                        //document.getElementById(card.id).classList.remove(`-${effect}`);
                        $(`#${card.id} .playing-card-wrapper`).removeClass(`-${effect}`);
                    }, timeout);
                }
            }
    
        }
    
        window.abilities = {
            
            modifiers: {
    
                //Checks special abilities on a card
                card(card) {
                    //Check immunity
                    if (abilities.modifiers.immunity(card)) { return true; }
    
                    //Check cancel
                    if (abilities.modifiers.cancel(card)) { return true; }
    
                    //Check evade
                    if (abilities.modifiers.evade(card)) { return true; }
    
                    return false;
                },
            
                //Check special abilities on a team
                team(card) {
                    //Check cancel
                    if (abilities.modifiers.cancel(card)) { return true; }
    
                    return false;
                },
            
                hp(card, value) {
    
                    if (card.abilityKey == '28D1F750-7D10-485C-AD16-3EC3B6B88860') {
                        return Math.round(abilities.modifiers.charm(value));
                    }
    
                    return value;
                },

                //Take 15% less damge from opponents ability
                charm: function(value) {
                    return Math.round(value * .85);
                },

                //Immune to all abilities
                immunity: function(card) {
                    if (card.abilityKey == '549FFD6F-D51F-4AAA-B4FF-37A567B6E441') {  return true; }

                    return false;
                },

                //35% chance of canceling opponents ability
                cancel: function(card) {
                    if (card.abilityKey == '556FD447-F4F5-44A9-AC11-F09552C79149' && Math.random() < .35) { return true; }

                    return false;
                },

                //40% chance of evading ability
                evade: function(card) {
                    if (card.abilityKey == 'D08C7E87-3BDA-4DD8-A7E3-4FD3CFB07A45' && Math.random() < .40) { return true; }

                    return false;
                },

                //20% chance to evade all opponents abilities
                evacuate: function() {
                    if (card.abilityKey == 'DD08601D-DA04-4BA9-AA5F-2CF02B11A021' && Math.random() < .20) { return true; }

                    return false;
                },
    
            },
    
            initial: {
    
                //Immediately deal damage to all cards on other team
                'F7D01FA2-FD64-4371-9F3B-8F8C77B2A4FA': function(team1, team2, index1, index2, events) {
                    if (abilities.modifiers.team(team2[index2])) { return; }
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
    
                    const card1 = team2[index1];
                    for (let i = index2; i < team2.length; i++) {
    
                        if (abilities.modifiers.card(team2[i])) { return; }
    
                        team2[i].hp = abilities.modifiers.hp(team2[i], Math.round(Number(team2[i].hp) - Number(card1.attack)));
                        effects.add(team2[i], ['glow-red']);
                    }
                },
    
                //50% chance to damage each team member between 10-20% damage
                '600D1E60-5C68-41F9-9A6C-7F3958B85B8C': function(team1, team2, index1, index2, events) {
                    if (abilities.modifiers.team(team2[index2])) { return; }
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    
                    for (let i = index2; i < team2.length; i++) {
    
                        if (abilities.modifiers.card(team2[i])) { return; }
    
                        if (Math.random() < .5) {
                            //Random damage between 10-20% 
                            let randomDamage = (Math.floor(Math.random() * 10) + 1) + 10;
                            randomDamage = 1 - (randomDamage * .01);
                            team2[i].hp = abilities.modifiers.hp(team2[i], Math.round(Number(team2[i].hp) * randomDamage));
                            effects.add(team2[i], ['wobble']);
                        }
                    }
                },
    
            },
    
            turn: {

                //Resurrect Fallen Ally
                '2D83A07C-C0E6-43D1-B8BC-D95A5E3C306B': function(team1, team2, index1, index2, events) {
                    const count = team1.length;
                    if (index1 > 0) {
                        //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                        const card = team1[Math.floor(Math.random() * index1)];
                        card.hp = card.originalHp;
                        team1.push(card);
                    }
                },

                //15% chance to convert enemy to own team with half health. Lowers all team attack by %5
                '57B18993-D9EC-41FF-A52D-CD49ADB7C370': function(team1, team2, index1, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    if (Math.random() < .10) {
                        const remainingCards = team2.length - index2;
                        const index = Math.floor(Math.random() * remainingCards) + index2;
                        let card = team2[index];
                        card.hp = card.originalHp / 2;
                        team2.splice(index, 1);
                        team1.push(card);
                    }
                    for (let i = index1; i < team1.length; i++) {
                        team1[i].attack = Math.round(team1[i].attack * .95);
                        effects.add(team1[i], ['glow-red']);
                    }
                },
    
                //25% chance to lower all Legendary and Ultra base stats to regular card.
                'DE61B5A5-0328-4D0D-9CE3-2A308894DD82': function(team1, team2, index1, index2, events) {
                    const ultraMultiplyer = 1.10;
                    const legendaryMultiplyer = 1.20;
    
                    if (Math.random() < .60) {
                        //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                        effects.add(team1[index1], ['jello']);
                        for (let i = index2; i < team2.length; i++) {
                            const tier = team2[i].tier;
                            if (tier == 3 || tier == 4) {
                                const percent = tier == 3 ? ultraMultiplyer : legendaryMultiplyer; 
                                team2[i].hp =  Math.round(Number(team2[i].hp) / percent);
                                team2[i].attack = Math.round(Number(team2[i].attack) / percent);
                                team2[i].defence = Math.round(Number(team2[i].defence) / percent);
                                team2[i].accuracy = Math.round(Number(team2[i].accuracy) / percent);
                                effects.add(team2[i], ['invert']);
                            }
                        }
                    }
                },
    
                //All team gain 95% accuracy
                'AC27A0EF-39A0-4A79-89A3-E1FDC39B335A': function(team1, team2, index1, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    for (let i = index1; i < team1.length; i++) {
                        team1[i].accuracy = 95;
                        effects.add(team1[i], ['tada']);
                    }
                },
    
                //Increased Team Critical Hit Chances by 20%
                'B6A0D6F4-C89C-4DDC-9C75-67DCF3A74FF1': function(team1, team2, index1, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    for (let i = index1; i < team1.length; i++) {
                        team1[i].criticalChance = team1[i].criticalChance * 1.2;
                        effects.add(team1[i], ['tada']);
                    }
                },
    
                //10% Chance to make knock out opponent and miss 3 goes
                '17186594-F21B-4572-B53D-96DC858606B2': function(team1, team2, index1, index2, events) {
                    if (abilities.modifiers.card(team2[index2])) { return; }
    
                    if (Math.random() < .1) {
                        //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                        team2[index2].turnSkips = 3;
                        effects.add(team2[index2], ['blur', 'jello']);
                    }
                },
    
                //Makes the Opponent miss 1 go.
                '34BB8768-0D31-4FD2-A02F-8095F20E7631': function(team1, team2, index1, index2, events) {
                    if (abilities.modifiers.card(team2[index2])) { return; }
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});

                    effects.add(team2[index2], ['grayscale']);
                    team2[index2].turnSkips = 1;
                },
    
                // //10% chance to damage each team member between 25-35% damage
                // cannonball: function(team1, team2, index1, index2, events) {
                //     if (abilities.modifiers.team(team2[index2])) { return; }
                    
                //     for (let i = index2; i < team2.length; i++) {
    
                //         if (abilities.modifiers.card(team2[i])) { return; }
    
                //         if (Math.random() < .1) {
                //             //Random damage between 25-35% 
                //             let randomDamage = (Math.floor(Math.random() * 10) + 1) + 25;
                //             randomDamage = 1 - (randomDamage * .01);
                //             team2[i].hp = abilities.modifiers.hp(team2[i], Math.round(Number(team2[i].hp) * randomDamage));
                //             effects.add(team2[i], ['rubberBand']);
                //         }
                //     }
                // },
    
                '89E57CEB-6E57-4AC5-A414-CC91AA8454F6': function(team1, team2, index1, index2, events) {
                    if (Math.random() < .6) {
                        //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                        for (let i = index2; i < team2.length; i++) {
    
                            if (abilities.modifiers.card(team2[i])) { return; }
                            
                            //Take of 1000. If less than a 1000 set it to 100
                            team2[i].hp = team2[i].hp > 1000 ? team2[i].hp - 1000 : 100;
                            effects.add(team2[i], ['wobble']);
                        }
                    }
                },
    
                //All team gain 10% hp
                '1A4B6777-A62C-40E4-AACC-F131626BAA6C': function(team1, team2, index1, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    if (Math.random() < .75) {
                        for (let i = index1; i < team1.length; i++) {
                            team1[i].attack = Math.round(Number(team1[i].attack) * 1.15);
                            effects.add(team1[i], ['tada']);
                        }
                    } else if (Math.random() < .15) {
                        for (let i = index1; i < team1.length; i++) {
                            team1[i].hp = Math.round(Number(team1[i].hp) * .85);
                            effects.add(team1[i], ['wobble']);
                        }
                    }
                },
    
                //All team gain 10% hp
                '8FD3CE34-9525-4BB8-B368-BB31440215C8': function(team1, team2, index1, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    for (let i = index1; i < team1.length; i++) {
                        team1[i].hp = Math.round(Number(team1[i].hp) * 1.1);
                        effects.add(team1[i], ['tada']);
                    }
                },
    
                //All team gain 5% accuracy, hp, and attack
                'DA65F421-A687-464A-A2A8-3E76064D0A79': function(team1, team2, index1, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    for (let i = index1; i < team1.length; i++) {
                        team1[i].hp = Math.round(Number(team1[i].hp) * 1.05);
                        team1[i].accuracy = Math.round(Number(team1[i].accuracy) * 1.05);
                        team1[i].attack = Math.round(Number(team1[i].attack) * 1.05);
                        effects.add(team1[i], ['tada']);
                    }
                },
    
                //All team gain 15% accuracy
                // eagleeye: function(team1, team2, index1, index2, events) {
                //     for (let i = index1; i < team1.length; i++) {
                //         team1[i].accuracy = Math.round(Number(team1[i].accuracy) * 1.15);
                //         effects.add(team1[i], ['tada']);
                //     }
                // },
    
                //All team gain 15% attack and defence
                'BBA5972E-80D5-4DA8-8BB8-7036880F4BAE': function(team1, team2, index1, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    for (let i = 1; i < team1.length; i++) {
                        team1[i].defence = Math.round(Number(team1[i].defence) * 1.05);
                        team1[i].attack = Math.round(Number(team1[i].attack) * 1.05);
                        effects.add(team1[i], ['tada']);
                    }
                },
    
                //Increased teams speed, defence, and attack by 10%.
                '60BFF20A-AAC8-447C-908E-5ED66B2C1F20': function(team1, team2, index1, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    for (let i = 1; i < team1.length; i++) {
                        team1[i].speed = Math.round(Number(team1[i].speed) * 1.10);
                        team1[i].defence = Math.round(Number(team1[i].defence) * 1.10);
                        team1[i].attack = Math.round(Number(team1[i].attack) * 1.10);
                        effects.add(team1[i], ['tada']);
                    }
                },
    
                //Increased teams critical hit, accuracy, and defence by 10%
                '32165844-9F43-4053-B8DE-A5E1495A4A0F': function(team1, team2, index1, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    for (let i = 1; i < team1.length; i++) {
                        team1[i].criticalChance = Math.round(Number(team1[i].criticalChance) * 1.10);
                        team1[i].accuracy = Math.round(Number(team1[i].accuracy) * 1.10);
                        team1[i].defence = Math.round(Number(team1[i].defence) * 1.10);
                        effects.add(team1[i], ['tada']);
                    }
                },
    
                '6F9B8656-133C-47D3-BF46-528063744FAA': function(team1, team2, index1, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    for (let i = 1; i < team2.length; i++) {
                        if (abilities.modifiers.card(team2[i])) { return; }
    
                        team2[i].accuracy = Math.round(Number(team2[i].accuracy) * 0.80);
                        effects.add(team2[i], ['shakeY']);
                    }
                },
    
                //All enemy team lose 20% accuracy
                '5A296611-7BCC-4D3E-B182-4E49A67281A9': function(team1, team2, index1, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    for (let i = 1; i < team2.length; i++) {
    
                        if (abilities.modifiers.card(team2[i])) { return; }
    
                        team2[i].accuracy = Math.round(Number(team2[i].accuracy) * 0.75);
                        
                        effects.add(team2[i], ['shakeY']);
                    }
                },
    
                //20% chance of stealing and using opponents ability
                'E344ECA0-9226-4B5A-B667-091AEBA1495F': function(team1, team2, index1, index2, events) {
                    const abilityKey = team2[index2].abilityKey;
    
                    if (Math.random() < .2) {
                        //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                        team1[index1].abilityKey = abilityKey;
                        team2[index2].abilityKey = null;
                        abilities[`${abilityKey}`](team1, team2);
                        effects.add(team2[index2], ['grayscale']);
                    }
                },
                
                //30% chance of increased attack by 20%
                '841E61C0-A015-44D5-A0A4-C95F357B77F3': function(team1, team2, index1, index2, events) {
                    if (Math.random() < .3) {
                        //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                        team2[index1].attack = Math.round(Number(team2[index1].attack) * 1.20);
                        effects.add(team2[i], ['tada']);
                    }
                },
    
                //Increased teams defense by 25%
                '3C191572-F547-4ED5-9F0E-78F7CC810835': function(team1, team2, index1, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    for (let i = 1; i < team1.length; i++) {
                        team1[i].defence = Math.round(Number(team1[i].defence) * 1.025);
                        effects.add(team1[i], ['tada']);
                    }
                },
    
                //Lowers his own team's speed by 10% but increased attack by 10% for team.
                '4D0F1E65-8894-4924-AFF4-F8A663B449B2': function(team1, team2, index1, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    for (let i = 1; i < team1.length; i++) {
                        team1[i].speed = Math.round(Number(team1[i].speed) * .90);
                        team1[i].attack = Math.round(Number(team1[i].attack) * 1.10);
                        effects.add(team1[i], ['tada']);
                    }
                },
    
                //Increase team speed by 15%
                '239266E3-E733-4569-91C3-DFD3336D773F': function(team1, team2, index1, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    for (let i = 1; i < team1.length; i++) {
                        team1[i].speed = Math.round(Number(team1[i].speed) * 1.15);
                        effects.add(team1[i], ['tada']);
                    }
                },
    
                //20% chance to evade all opponents abilities
                //This one will have a 20% chance off avoiding ability with modifier.evacuate
                //Then when it's it's turn it has a 20% chance of getting immunity
                'DD08601D-DA04-4BA9-AA5F-2CF02B11A021': function(team1, team2, index1, index2, events) {
                    if (Math.random() < .20) {
                        //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                        team2[index2].ability == 'immunity';
                    }
                },
    
                //Lower enemies accuracy by 15% and defence by %5
                'A0EBE149-28DE-4177-A393-85A17E479A7D': function(team1, team2, index1, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    const card2 = team2[index2];
                    card2.accuracy = Math.round(Number(card2.accuracy) * .85);
                    card2.defence = Math.round(Number(card2.defence) * .95);
                    effects.add(card2, ['shakeY']);
                },
    
                //Enemy takes 1000 damage 
                '7C923295-6BAE-4D50-8E4D-4E96D1FE35CD': function(team1, team2, index1, index2, events) {
                    const card2 = team2[index2];
    
                    if (abilities.modifiers.card(card2)) { return; }

                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
    
                    card2.hp = abilities.modifiers.hp(card2, Number(card2.hp) - 2000);
    
                    effects.add(team1[index1], ['powerup']);
                    effects.add(card2, ['glow-red', 'blur']);
                },
    
                //Enemy losses 10% accuracy and hp
                '4518D1D0-216D-4C7C-8249-2417C3DC0EBA': function(team1, team2, index1, index2, events) {
                    const card2 = team2[index2];
    
                    if (abilities.modifiers.card(card2)) { return; }

                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
    
                    card2.accuracy = Math.round(Number(card2.accuracy) * 0.9);
                    card2.hp = abilities.modifiers.hp(card2, Math.round(Number(card2.hp) * 0.9));
                    effects.add(card2, ['shakeY']);
                },
    
                //All enemy team take 300 damage //TODO: no idea what would be a good number here
                '7E919D90-C7CA-48CE-9A5B-0DE6F52B1A9D': function(team1, team2, index1, index2, events) {
                    if (abilities.modifiers.team(team2[index2])) { return; }
                    
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});

                    for (let i = 1; i < team2.length; i++) {
    
                        if (abilities.modifiers.card(team2[i])) { return; }
    
                        team2[i].hp = abilities.modifiers.hp(team2[i], Number(team2[i].hp) - 300);
                        effects.add(team2[i], ['rubberBand']);
                    }
                },
    
                //Steal 15% of current enemies current hp
                '3518D1D0-216D-4C7C-8249-2417C3DC0EBA': function(team1, team2, index1, index2, events) {
                    const card1 = team2[index1], card2 = team2[index2];
    
                    if (abilities.modifiers.card(card2)) { return; }

                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
    
                    const health = Math.round(Number(card2.hp) * 0.15);
                    card1.hp = abilities.modifiers.hp(card2, Number(card1.hp) + health);
                    card2.hp = abilities.modifiers.hp(card2, Number(card2.hp) - health);
                    effects.add(card1, ['glow-green']);
                    effects.add(card2, ['glow-red']);
                },
    
                //Reduce the accuracy of the current enemy by 35%
                //TODO change this if we have speed?
                // speed: function(team1, team2, index1, index2, events) {
                //     const card2 = team2[index2];
    
                //     if (abilities.modifiers.card(card2)) { return; }
    
                //     card2.accuracy = Math.round(Number(card2.accuracy) * 0.65);
                //     effects.add(card2, ['shakeY']);
                // },
    
                //Reduce the hp of the lowest hp current card by 40% of current hp
                //Do nothing if hp is the same
                '5AFD1B11-23CE-42E9-A058-9D2D9BE0821B': function(team1, team2, index1, index2, events) {
                    if (abilities.modifiers.team(team2[index2])) { return; }
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    
                    const card1 = team2[index1], card2 = team2[index2];
                    if (Number(card1.hp) < Number(card2. hp)) {
    
                        if (abilities.modifiers.card(card1)) { return; }
    
                        card1.hp = abilities.modifiers.hp(card1, Math.round(Number(card1.hp) * 0.6));
                    } else if (Number(card2.hp) < Number(card1. hp)) {
    
                        if (abilities.modifiers.card(card2)) { return; }
    
                        card2.hp = abilities.modifiers.hp(card2, Math.round(Number(card2.hp) * 0.6));
                    }
                },
    
                //All team gain hp equal to 10% of the current enemies current hp
                'FB27CBBE-272E-4880-8E2F-05D8DBED1DEA': function(team1, team2, index1, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    for (let i = index1; i < team1.length; i++) {
                        team1[i].hp = Math.round(Number(team1[i].hp) * 1.15);
                        effects.add(team1[i], ['glow-green']);
                    }
                },
    
                //25% chance that the enemy immediately damages itself
                '3518D1D0-216D-4C7C-8249-2437C3DC0EBA': function(team1, team2, index1, index2, events) {
                    const card2 = team2[index2];
    
                    if (abilities.modifiers.card(card2)) { return; }
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
    
                    if (Math.random() < 0.25) {
                        card2.hp = abilities.modifiers.hp(card2, Number(card2.hp) - Number(card2.attack));
                        effects.add(card2, ['jello', 'grayscale']);
                    }
                },
    
                //5% Chance to do up to 10,000 damage in one blow
                '563D6C6F-0E65-4EFF-8198-1D1B5B79C16D': function(team1, team2, index1, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    const card2 = team2[index2];
                    const maxDamage = 10000;
                    const damage = card2.hp < maxDamage ? Math.round(Number(card2.hp) * .95) : maxDamage;
    
                    card2.hp = abilities.modifiers.hp(card2, damage); 
                    effects.add(card2, ['invert']);
                },
    
                //Lower percentage of enemy's random stat by 15%
                '045A0C5F-F3F7-4B05-AC9B-2B79BA3EB32C': function(team1, team2, index1, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    const card2 = team2[index2];
                    const chance = Math.floor(Math.random() * 4) + 1;
                    const percent = .85;
                    switch(chance) {
                        case 1:
                            card2.hp =  abilities.modifiers.hp(card2, Math.round(Number(card2.hp) * percent));
                            break;
                        case 2:
                            card2.attack = Math.round(Number(card2.attack) * percent);
                            break;
                        case 3:
                            card2.defence = Math.round(Number(card2.defence) * percent);
                            break;
                        case 4:
                            card2.accuracy = Math.round(Number(card2.accuracy) * percent);
                            break;
                    }
                    effects.add(card2, ['shakeY']);
                },
    
                //Lower enemies attack by random percent. 10-50%
                'D8EF6C1C-CA66-4287-AE74-2276AE737B2A': function(team1, team2, index1, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    const card2 = team2[index2];
                    const percent = 1 - ((Math.round(Math.random() * 40) + 10) * .01)
                    card2.attack = Math.round(Number(card2.attack) * percent);
                    effects.add(card2, ['shakeY']);
                },
    
                //Lower all enemies speed by 15%
                'BA9B4A17-B7DF-47EF-9DB1-56CA41402A65': function(team1, team2, index1, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    team2[index2].speed = Math.round(Number(team2[index2].speed) * .85);
                    effects.add(team2[index2], ['shakeY']);
                },
    
                //Make opponent slower by 25%
                '00CD39C2-D55F-4F12-AE75-9AB33ACCEE69': function(team1, team2, index1, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    team2[index2].speed = Math.round(Number(team2[index2].speed) * .75);
                    effects.add(team2[index2], ['shakeY']);
                },
    
                //33% chance to remove one opponent's card's entire defence
                'A65A32E6-DEB8-431F-BC76-3B2C9C649951': function(team1, team2, index1, index2, events) {
                    const card2 = team2[index2];
                    if (Math.random() < .33) {
                        //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                        card2.defence = 0;
                        effects.add(card2, ['shakeY']);
                    }
                },
    
                '03FBC641-8B42-4F29-9B14-0DEA3D180E8A': function(team1, team2, index1, index2, events) {
                    const card2 = team2[index2];
                    if (Math.random() < .25) {
                        //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                        if (card2.abilityKey && typeof abilities.initial[`${card2.abilityKey}`] === 'function') {
                            abilities.initial[`${card2.abilityKey}`](team1, team2, index1, index2);
                            effects.add(card2, ['tada']);
                        } else if (card2.abilityKey && typeof abilities.turn[`${card2.abilityKey}`] === 'function') {
                            abilities.turn[`${card2.abilityKey}`](team1, team2, index1, index2);
                        }
                    }
                }
    
            },
    
            move: {
    
                //Heals 100 Health Points every turn it's alive. 
                'F05FE879-9ADE-4180-A54B-10E411005569': function(team1, team2, index1, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    team1[index1].hp += 100;
                    effects.add(team1[index1], ['glow-green']);
                },
    
                //Team Defence increases by 5% every turn
                '820FD99B-8205-48C6-BE06-CC64569C3C13': function(team1, team2, index1, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    for (let i = index1; i < team1.length; i++) {
                        team1[i].defence = Math.round(Number(team1[i].defence) * 1.01);
                        //effects.add(team1[i], ['tada']);
                    }
                },
    
                //Defense, attach, and critical increased by 10% each turn
                '8C87C40B-2C92-4C5E-82C4-4DD2E516EEE3': function(team1, team2, index1, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    team1[index1].attack = Math.round(Number(team1[index1].attack) * 1.05);
                    team1[index1].criticalChance = Math.round(team1[index1].criticalChance * 1.05);
                    effects.add(team1[index1], ['glow-green']);
                }
    
            },
    
            damaged: {
    
                //10% chance to absorb damage and convert it into health. 10% chance to reflect damge.
                '08CE6F9D-EA9F-4785-A662-287581805F98': function(team1, team2, index1, index2, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    const card1 = team1[index1];
                    if (Math.random() < .2) {
                        //The damage was removed so we add back double the hp
                        card1.hp += Math.round(damage * 2);
                        effects.add(card1, ['glow-green']);
                    } else if (Math.random() < .2) {  
                        //The damage was removed so we add back the hp
                        card1.hp += damage;
                        team2[index2].hp -= Math.round(damage * 2);
                        effects.add(team2[index2], ['glow-red']);
                        effects.add(card1, ['glow-green']);
                    }
                },
    
                //2% increased defence every time he gets hit.
                'EF4391C1-99FD-4C3B-AFFC-AF740E08FF35': function(team1, team2, index1, index2, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    team1[index1].defense = Math.round(team1[index1].defense * 1.02);
                },
    
                //20% increased defence every time he gets hit.
                '19B3CB51-6EA0-41AB-A963-D0B34C77F3B6': function(team1, team2, index1, index2, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    team1[index1].attack = Math.round(team1[index1].attack * 1.05);
                    effects.add(team1[index1], ['glow-red']);
                },
    
                'AAF87AD9-AB91-42E6-8B36-D197D5A96873': function(team1, team2, index1, index2, index2, events) {
                    if (Math.random() < .1) {
                        //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                        team1[index1].hp += damage;
                        effects.add(team1[index1], ['glow-green']);
                    }
                },
    
                '8D9FCBE7-7E41-4D8F-9073-B9E8D075DE45': function(team1, team2, index1, index2, index2, events) {
                    if (Math.random() < .35) {
                        //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                        team1[index1].hp += damage;
                        effects.add(team1[index1], ['shine']);
                    }
                },
    
                '6327C132-DDDD-47E3-B603-95B29B8C0899': function(team1, team2, index1, index2, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    team1[index1].speed = Math.round(team1[index1].speed * 1.02);
                    effects.add(team1[index1], ['blur']);
                },
                
                '9468A8F3-E931-4BAB-874F-4F0997331E54' : function(team1, team2, index1, index2, index2, events) {
                    //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                    team1[index1].hp = Math.round(team1[index1].hp * 1.02);
                    effects.add(team1[index1], ['glow-green']);
                },
    
                'DC18CA09-6F12-4E8E-91C6-8905EA1BC0B9': function(team1, team2, index1, index2, index2, events) {
                    if (Math.random() < .7) {
                        //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                        team1[index1].hp += damage;
                        effects.add(team1[index1], ['glow-green']);
                    }
                    team1[index1].abilityKey = null;
                },
    
                '3897C04E-110B-4705-A502-33E5E9B3C762': function(team1, team2, index1, index2, index2, events) {
                    if (Math.random() < .2) {
                        //events.push({cardId: team1[index1].id, abilityId: team1[index1].abilityKey});
                        team1[index1].hp = Math.round(team1[index1].hp * 1.40);
                        team1[index1].abilityKey = null;
                        effects.add(team1[index1], ['glow-green']);
                    }
                }
    
            }
        }
    
    })();